export default __webpack_public_path__ + "static/media/Left.fe38ddfd.svg";